import PropTypes from 'prop-types'
import React from 'react'
import { StarRating } from './StarRating'

export interface OptionalRatingStarsProps {
  rating?: number
}

export function OptionalRatingStars ({ rating }: OptionalRatingStarsProps): React.ReactElement {
  if (typeof rating === 'number' && rating >= 0 && rating <= 50) {
    return <StarRating rating={rating} />
  }
  return <span className='font-italic'>Not Available</span>
}

OptionalRatingStars.propTypes = {
  rating: PropTypes.number
}
